import { createFileRoute } from "@tanstack/react-router";

import { RoutePage, routeEntry } from "./routeTable";

const entry = routeEntry("/data/feed-driven");

export const Route = createFileRoute("/data/feed-driven")({
  head: () => ({
    meta: [
      { title: "Feed-driven data — LevelLoad" },
      { name: "description", content: "Automated data feeds consumed by LevelLoad." },
      { property: "og:title", content: "Feed-driven data — LevelLoad" },
      { property: "og:description", content: "Automated data feeds consumed by LevelLoad." },
      { property: "og:type", content: "website" },
      { name: "twitter:card", content: "summary_large_image" },
    ],
  }),
  component: RouteComponent,
});

function RouteComponent() {
  return <RoutePage entry={entry} />;
}
